import React from 'react';

export type AnnotationAnchorProps = {
  /** Source offsets of this fragment in the body Markdown. */
  srcStart?: number;
  srcEnd?: number;
  children?: React.ReactNode;
};

/**
 * Renders one unannotated text fragment, carrying its source range.
 *
 * Visually inert on purpose -- it exists so a mouse selection can be resolved
 * to a Markdown source offset. See ANCHOR_NODE in annotation-mdast-plugin.ts
 * for why the offsets cannot be recovered from the DOM text alone.
 */
export const AnnotationAnchor: React.FC<AnnotationAnchorProps> = ({
  srcStart,
  srcEnd,
  children
}) => (
  <span
    className="cmx-document-content-anchor"
    data-src-start={srcStart}
    data-src-end={srcEnd}
  >
    {children}
  </span>
);
